import React from 'react';

function RequiredAstric() {
	return (
		<span className='text-danger'>*</span>
	);
}

export default RequiredAstric;